import { ReactNode } from "react";

interface ButtonGroupProps {
  children: ReactNode;
  orientation?: "horizontal" | "vertical";
  fullWidth?: boolean;
  className?: string;
}

export function ButtonGroup({
  children,
  orientation = "horizontal",
  fullWidth = false,
  className = "",
}: ButtonGroupProps) {
  const orientationStyles =
    orientation === "horizontal"
      ? "[&>*:first-child]:rounded-l-lg [&>*:last-child]:rounded-r-lg [&>*:not(:last-child)]:border-r-0"
      : "flex-col [&>*:first-child]:rounded-t-lg [&>*:last-child]:rounded-b-lg [&>*:not(:last-child)]:border-b-0";

  return (
    <div
      className={`inline-flex [&>*]:rounded-none ${orientationStyles} ${fullWidth ? "w-full [&>*]:flex-1" : ""} ${className}`}
    >
      {children}
    </div>
  );
}

export type { ButtonGroupProps };
